import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import StyledText from '#components/a/StyledText'
import NavVersetzungsplan from '#components/svg/icons/NavVersetzungsplan'
import {routeKeys} from '#config/routeKeys'

function VersetzungsplanPublishBenachrichtigung({onNotificationClick}) {
  const onClickNotification = () => {
    onNotificationClick(routeKeys.ablaufundtermine)
  }

  const text = i18n.t('notification_text_publish_versetzungsplan')
  return (
    <div
      role="button"
      tabIndex={0}
      className="notification"
      onClick={onClickNotification}
      onKeyPress={onClickNotification}
      data-testid="versetzungsplan-publish-notification">
      <div className="notification__icon">
        <NavVersetzungsplan />
      </div>
      <StyledText text={text} modifier="notification" />
    </div>
  )
}

VersetzungsplanPublishBenachrichtigung.propTypes = {
  onNotificationClick: PropTypes.func.isRequired,
}

export default VersetzungsplanPublishBenachrichtigung
